import { render, staticRenderFns } from "./SecondSection.vue?vue&type=template&id=20cc201b&scoped=true&"
import script from "./SecondSection.vue?vue&type=script&lang=js&"
export * from "./SecondSection.vue?vue&type=script&lang=js&"
import style0 from "./SecondSection.vue?vue&type=style&index=0&id=20cc201b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cc201b",
  null
  
)

export default component.exports